// extracted by mini-css-extract-plugin
export default {"contentPage":"Profile_contentPage__LOqSd","redirecting":"Profile_redirecting__SF5Xi"};